<template>
  <div class="WebsiteVisibilityOption">
    <span class="WebsiteVisibilityOption__icon-tile">
      <UIIcon
        :name="icon"
        class="WebsiteVisibilityOption__icon"
        aria-hidden="true"
      />
    </span>

    <div class="WebsiteVisibilityOption__info">
      <span class="WebsiteVisibilityOption__label">{{ label }}</span>
      <p class="WebsiteVisibilityOption__description">{{ description }}</p>
    </div>

    <UIIcon
      v-if="isSelected"
      name="checkRegular"
      class="WebsiteVisibilityOption__check"
      aria-hidden="true"
    />
  </div>
</template>

<script lang="ts" setup>
import { UIIcon, type IIcons } from '@foundever/ui-lib'

defineProps<{
  label: string
  description: string
  icon: IIcons
  isSelected?: boolean
}>()
</script>

<style scoped lang="scss">
.WebsiteVisibilityOption {
  display: flex;
  align-items: center;
  gap: var(---fds-global-space-sm);
  width: 100%;
  cursor: pointer;

  .WebsiteVisibilityOption__icon-tile {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    width: 2rem;
    height: 2rem;
    border: 1px solid var(--border-default);
    border-radius: var(--radius-s);
    background-color: var(--bg-primary);
  }

  .WebsiteVisibilityOption__icon {
    --size: 1rem;
    --color: var(--icon-tertiary);
  }

  .WebsiteVisibilityOption__info {
    display: flex;
    flex-direction: column;
    gap: var(---fds-global-space-xxxs);
    min-width: 0;
    // The dropdown toggle is a <button>, whose centred text alignment would
    // otherwise centre the label inside this column.
    text-align: left;
  }

  .WebsiteVisibilityOption__label {
    @include font-body-small-medium;
    color: var(--text-primary);
  }

  .WebsiteVisibilityOption__description {
    @include font-caption-regular;
    margin: 0;
    color: var(--text-secondary);
  }

  .WebsiteVisibilityOption__check {
    --size: 1.25rem;
    --color: var(--icon-accent);
    flex: 0 0 auto;
    margin-left: auto;
  }
}
</style>
